export default __webpack_public_path__ + "static/media/movipack_feature3hover.08c8d9c2.svg";